import script from "./ExperimentReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperimentReport.vue?vue&type=script&setup=true&lang=js"

import "./ExperimentReport.vue?vue&type=style&index=0&id=b6978964&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6978964"]])

export default __exports__